<ion-header>
  <ion-toolbar>
    <ion-searchbar
      #searchBar
      placeholder="Buscar país"
      type="text"
      (ionCancel)="close()"
      (ionInput)="onSearchChange($event)"
      [debounce]="250"
      showCancelButton="always"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    <ion-item *ngFor="let item of countries | slice : 0 : end" button detail (click)="close(item)">
      <ion-label
        ><span class="fi fi-{{ item.iso2 | lowercase }}"></span> &ensp;
        <span *ngIf="showCode">+{{ item.phoneCode }}</span> {{ item.nameES }}</ion-label
      >
    </ion-item>
  </ion-list>

  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
